import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementCompany } from 'ogp/services/service-agreements.schema';
import { LenderServiceAgreementInfo } from '../service-agreement-detail/tabs/information/service-agreement-info';
import { ServiceAgreementStateChip } from '../service-agreement-detail/service-agreement-state-chip';

type ServiceAgreementTabProps = {
  serviceAgreement: ServiceAgreementCompany['serviceAgreement'];
};

export const ServiceAgreementTab = ({ serviceAgreement }: ServiceAgreementTabProps) => {
  const { t } = useTranslation(['ogp-screen-specific', 'all-platforms-common']);

  return (
    <Box role="tabpanel">
      <Box display="flex" alignItems="center" gap={2} mb={4}>
        <Typography variant="subtitle1" color="secondary" noWrap>
          {t('service-agreement.subheader', {
            role: t('service-agreement.lender', { ns: 'all-platforms-common' }),
            ns: 'ogp-screen-specific',
          })}
        </Typography>
        <ServiceAgreementStateChip type={serviceAgreement.state} />
      </Box>
      <LenderServiceAgreementInfo data={serviceAgreement} />
    </Box>
  );
};
